import {Component, OnInit} from '@angular/core';

import { FormControl, FormsModule, ReactiveFormsModule } from "@angular/forms";
import {ActivatedRoute, Router} from "@angular/router";
import {UserService} from "../../services/user.service";
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { NgIf } from '@angular/common';

import { resetPassword, confirmResetPassword, signIn} from 'aws-amplify/auth';

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss'],
    standalone: true,
    imports: [NgIf, MatFormFieldModule, MatInputModule, FormsModule, ReactiveFormsModule, MatButtonModule]
})
export class ForgotPasswordComponent implements OnInit {

  returnUrl?: string ;

  email = new FormControl('');

  code = new FormControl('');

  password = new FormControl('');
  password2 = new FormControl('') ;

  codeSent: boolean = false ;

  constructor(
    private users: UserService,
    private router: Router,
    private route: ActivatedRoute
  ) {
  }

  ngOnInit(): void {
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] ;
  }


  async getCode() {

    try {
      const username = this.users.getUsername(this.email.value!);

      let result: any = await resetPassword({username});
      this.codeSent = true ;
      console.log(result) ;
    }
    catch (e) {
      this.email.setErrors({ invalidEmail: true });
      this.email.markAsTouched();
    }
  }

  async setPassword() {

    if (this.password.value != this.password2.value) {
      this.password2.setErrors({passwordMismatch: true}) ;
      this.password2.markAsTouched();
      return ;
    }

    try {
      const username = this.users.getUsername(this.email.value!);

      let result: any = await confirmResetPassword({
        username: username,
        confirmationCode: this.code.value!,
        newPassword: this.password.value!
      });

      await this.autoSignin();
    }
    catch (e:any) {

      if (e.name === 'CodeMismatchException') {
        this.code.setErrors({ invalidCode: true });
        this.code.markAsTouched();
      }

      if (e.name == 'InvalidPasswordException') {
        this.password.setErrors({invalid: true});
      }

      console.log(e);
    }
  }

  async autoSignin() {
    try {
      const authResult = await signIn({
        username: this.email.value!,
        password: this.password.value!
      }) ;

      console.log(authResult);

      await this.finaliseAndRedirect();
    } catch (e:any) {

      console.log(e);
    }
  }


  async finaliseAndRedirect() {

    if (this.returnUrl) {
      await this.router.navigateByUrl(this.returnUrl);
    } else {
      await this.router.navigateByUrl('/');
    }

  }


}
